import {Form} from "react-bootstrap";
import FeatherIcon from "feather-icons-react";
import React from "react";

const ErrorMessage = ({error}) => {
    if (!error) return null;
    return (
        <Form.Text className="text-muted alarm">
            <FeatherIcon icon="alert-circle"/> {error}
        </Form.Text>
    );
};

export default ErrorMessage;